import { render } from "./StudentCourse.vue?vue&type=template&id=6e280616&scoped=true"
import script from "./StudentCourse.vue?vue&type=script&lang=js"
export * from "./StudentCourse.vue?vue&type=script&lang=js"

import "./StudentCourse.vue?vue&type=style&index=0&id=6e280616&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.1.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e280616"]])

export default __exports__